import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, Users, LogOut, Menu, X, ChevronRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const NAV_ITEMS = [
  { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { path: '/admin/products', icon: Package, label: 'Products' },
  { path: '/admin/orders', icon: ShoppingBag, label: 'Orders' },
  { path: '/admin/users', icon: Users, label: 'Users' },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--black)' }}>
      {/* Sidebar */}
      <aside style={{ width: collapsed ? '64px' : '240px', background: 'var(--dark)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', transition: 'width 0.3s ease', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100, overflow: 'hidden' }}>
        {/* Logo */}
        <div style={{ padding: '24px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {!collapsed && <span style={{ fontFamily: 'var(--font-display)', fontSize: '20px', color: 'var(--gold)', letterSpacing: '0.1em', whiteSpace: 'nowrap' }}>LUMIÈRE</span>}
          <button onClick={() => setCollapsed(!collapsed)} style={{ background: 'none', color: 'var(--white-dim)', flexShrink: 0, marginLeft: collapsed ? 'auto' : 0 }}>
            {collapsed ? <ChevronRight size={16} /> : <X size={16} />}
          </button>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '16px 0' }}>
          {NAV_ITEMS.map(({ path, icon: Icon, label, end }) => (
            <NavLink key={path} to={path} end={end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 20px',
              color: isActive ? 'var(--gold)' : 'var(--white-dim)',
              background: isActive ? 'rgba(201,168,76,0.08)' : 'transparent',
              borderLeft: isActive ? '2px solid var(--gold)' : '2px solid transparent',
              fontSize: '13px', letterSpacing: '0.05em', transition: 'all 0.2s',
              whiteSpace: 'nowrap', overflow: 'hidden',
            })}>
              <Icon size={18} style={{ flexShrink: 0 }} />
              {!collapsed && label}
            </NavLink>
          ))}
        </nav>

        {/* User + Logout */}
        <div style={{ padding: '16px 20px', borderTop: '1px solid var(--border)' }}>
          {!collapsed && (
            <div style={{ marginBottom: '12px' }}>
              <p style={{ fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</p>
              <p style={{ fontSize: '10px', color: 'var(--gold)', letterSpacing: '0.1em' }}>ADMIN</p>
            </div>
          )}
          <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'none', color: 'var(--white-dim)', fontSize: '12px', letterSpacing: '0.05em', transition: 'color 0.2s', whiteSpace: 'nowrap' }}
            onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--white-dim)'}
          ><LogOut size={16} style={{ flexShrink: 0 }} />{!collapsed && 'Sign Out'}</button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex: 1, marginLeft: collapsed ? '64px' : '240px', transition: 'margin-left 0.3s ease', minHeight: '100vh', overflow: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
